export const API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY = 'API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY';
export const API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY_SUCCESS = 'API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY_SUCCESS';
export const API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY_FAIL = 'API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY_FAIL';

export const API_ADMIN_GET_ANSWEROPTIONLIBRARY = 'API_ADMIN_GET_ANSWEROPTIONLIBRARY';
export const API_ADMIN_GET_ANSWEROPTIONLIBRARY_SUCCESS = 'API_ADMIN_GET_ANSWEROPTIONLIBRARY_SUCCESS';
export const API_ADMIN_GET_ANSWEROPTIONLIBRARY_FAIL = 'API_ADMIN_GET_ANSWEROPTIONLIBRARY_FAIL';

export const API_ADMIN_POST_ANSWEROPTIONLIBRARY = 'API_ADMIN_POST_ANSWEROPTIONLIBRARY';
export const API_ADMIN_POST_ANSWEROPTIONLIBRARY_SUCCESS = 'API_ADMIN_POST_ANSWEROPTIONLIBRARY_SUCCESS';
export const API_ADMIN_POST_ANSWEROPTIONLIBRARY_FAIL = 'API_ADMIN_POST_ANSWEROPTIONLIBRARY_FAIL';

export const API_ADMIN_PATCH_ANSWEROPTIONLIBRARY = 'API_ADMIN_PATCH_ANSWEROPTIONLIBRARY';
export const API_ADMIN_PATCH_ANSWEROPTIONLIBRARY_SUCCESS = 'API_ADMIN_PATCH_ANSWEROPTIONLIBRARY_SUCCESS';
export const API_ADMIN_PATCH_ANSWEROPTIONLIBRARY_FAIL = 'API_ADMIN_PATCH_ANSWEROPTIONLIBRARY_FAIL';

export const API_ADMIN_DELETE_ANSWEROPTIONLIBRARY = 'API_ADMIN_DELETE_ANSWEROPTIONLIBRARY';
export const API_ADMIN_DELETE_ANSWEROPTIONLIBRARY_SUCCESS = 'API_ADMIN_DELETE_ANSWEROPTIONLIBRARY_SUCCESS';
export const API_ADMIN_DELETE_ANSWEROPTIONLIBRARY_FAIL = 'API_ADMIN_DELETE_ANSWEROPTIONLIBRARY_FAIL';

export const ADMIN_INIT_NEW_ANSWEROPTIONLIBRARY = 'ADMIN_INIT_NEW_ANSWEROPTIONLIBRARY'
export const ADMIN_RESET_FOCUS_ANSWEROPTIONLIBRARY = 'ADMIN_RESET_ANSWEROPTIONLIBRARY'